// Round 24 Item 3: synthetic Start node — always rendered at the top of
// every CanvasWorkflowPanel. Marks the implicit entry point so authors see
// a complete chain even before wiring any triggers. Read-only.
// When data.timingText is present (IP Start carries the InteractivePlugin
// box's resolved timing) it is displayed as a small chip row below the header.
import React from "react";
import { Handle, Position } from "@xyflow/react";

export default function StartNode({ data }) {
  const label = (data && data.label) || "Start";
  const timingText = data && data.timingText;
  return (
    <div
      className={`canvas-wf-node canvas-wf-node--start${timingText ? " canvas-wf-node--start-timed" : ""}`}
    >
      <div className="canvas-wf-node__head">
        <i className="material-icons">play_arrow</i>
        <span className="canvas-wf-node__kind">{label}</span>
      </div>
      {timingText && <div className="canvas-wf-node__start-timing">{timingText}</div>}
      <Handle type="source" id="out" position={Position.Right} />
    </div>
  );
}
